import React from 'react';
import { RouteComponentProps } from 'react-router';
import gql from 'graphql-tag';
import { ChildProps } from 'react-apollo';

import FeedbackHelpers from './feedback_helpers';
import FeedbackList from './feedback_list';
import { CoreShopFeedback } from '../../../schemas/rql';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { MarketplacePathContext } from '../../shared/url_helpers';

type RouteProps = RouteComponentProps<MarketplacePathContext, {}>;
type Props = RouteProps & ChildProps<RouteProps, CoreShopFeedback.Query, CoreShopFeedback.Variables>;
class ShopFeedback extends React.Component<Props, null> {
  get isShopLoaded(): boolean {
    return !!this.props.data.shop;
  }

  get shopSlug(): string {
    return this.isShopLoaded && this.props.data.shop.slug;
  }

  componentDidMount() {
    if (this.isShopLoaded) {
      this.loadFeedback();
    }
  }

  componentDidUpdate() {
    if (this.isShopLoaded) {
      this.loadFeedback();
    }
  }

  loadFeedback() {
    FeedbackHelpers.fetchUnlessLoaded(this.props.data.shop);
  }

  render() {
    return (
      <FeedbackList
        shopSlug={this.shopSlug}
      />
    );
  }
}

const connect = withGraphql<
RouteProps,
CoreShopFeedback.Query,
CoreShopFeedback.Variables
>(
  gql`
    query Core_Shop_Feedback($shop: String) {
      shop(input: { slug: $shop }) {
        _id
        id
        slug
      }
    }
  `,
  {
    options: (props) => ({
      ssr: false, // not important for SEO or initial page rendering
      variables: {
        shop: props.params.shop,
      },
    }),
  },
);

export default connect(ShopFeedback);
